<template>
    <div class="auto-list form-control">
        <!-- optional indicators -->
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <template v-else>
            <i class="fa fa-search" v-show="isEmpty"></i>
            <i class="fa fa-times" v-show="isDirty" @click="reset"></i>
        </template>

        <!-- the input field -->
        <input type="hidden" v-bind:name="name + '_id'" v-model="template.public_id"/>
        <input v-bind:name="name" class="popup-input form-control" v-model="template.name" type="text" placeholder="Type in the name" autocomplete="off" @keydown.down.prevent="down" @keydown.up.prevent="up" @keydown.enter="hit" @keydown.right="hit" @keydown.esc="reset" @blur="reset" @focus="keydown" @input="keydown" />

        <!-- the list -->
        <ul v-show="hasItems">
            <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
                <span v-text="item.name"></span>
            </li>
        </ul>
    </div>
</template>

<script>
    import VueTypeahead from '../../methods/vue-typeahead.js';
    export default {
        mixins: [VueTypeahead], // vue@1.0.21-
        props: {
            name: { default : 'template' },
            store: { default : false },
            template: { default: function() {
                    return {
                        public_id: '0',
                        name: ''
                    };
            }}
        },
        data () {
            return {
                val: 0,
                // The source url
                src: '/api/email/template/list',
                // The minimum character length needed before triggering
                minChars: false, // (optional)
                queryParamName: 'search'
            }
        },

        created () {
            if (this.template && this.template != 'false') {
                this.query = this.template.name;
                this.val = parseInt(this.template.public_id);
                // $("input[name='amount']").val(this.template.balance);
            }
        },

        methods: {
            reset () {
                this.items = [];
                this.loading = false;
            },

            keydown() {
                this.query = this.template.name;
                this.update();
            },

            update: function update() {
                var _this = this;

                if (this.minChars && this.query.length < this.minChars) {
                    return;
                }

                this.loading = true;

                this.fetch().then(function (response) {
                    var data = response.data;
                    data = _this.prepareResponseData ? _this.prepareResponseData(data) : data;
                    _this.items = _this.limit ? data.slice(0, _this.limit) : data;
                    _this.current = -1;
                    _this.loading = false;

                    if (_this.selectFirst) {
                        _this.down();
                    }
                });
            },

            // The callback function which is triggered when the user hits on an item
            // (required)
            onHit (item) {
                if (this.name == 'template') {
                    this.$root.loadTemplate(item.public_id);
                }
                this.val = item.public_id;
                this.query = item.name;
                if (typeof window.formData !== 'undefined') {
                    window.formData = jQuery.extend(formData, item);
                } else { // Fallback
                    window.formData = item;
                }
                this.$eventHub.$emit('reset-data');
                this.reset();
            }
        }
    }
</script>
